export default "__VITE_ASSET__a3751255__"